import React from 'react';
import { CountdownTimer } from './CountdownTimer';
export const Header = () => {
  return <header className="w-full bg-gradient-to-b from-gray-200 to-gray-100 py-8 px-4 md:px-8" data-id="element-182">
      <div className="max-w-5xl mx-auto" data-id="element-183">
        {/* Attention-grabbing headline */}
        <h1 className="text-3xl md:text-5xl font-bold text-gray-800 text-center mb-4" data-id="element-184">
          Krzyczałam na rodzinę przez głupi kubek - ale badania które znalazłam
          tamtej nocy ujawniły dlaczego 89% matek wybucha z byle powodu.
        </h1>
        {/* Emotional image */}
        <div className="relative w-full max-w-3xl mx-auto my-6" data-id="element-185">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/18pPWuoEJVDgHW7JQAfMi9/11.png" alt="Zestresowana kobieta trzymająca się za głowę" className="w-full rounded-lg shadow-lg" data-id="element-186" />
          <div className="absolute -bottom-4 -right-4 bg-red-600 text-white py-2 px-4 rounded-full shadow-lg transform rotate-3" data-id="element-187">
            <p className="font-bold text-sm md:text-base" data-id="element-188">
              Badania ujawniają szokującą prawdę!
            </p>
          </div>
        </div>
        {/* Subheadline with emotional triggers */}
        <div className="mt-8 text-center" data-id="element-189">
          <h2 className="text-xl md:text-2xl text-gray-700 mb-4" data-id="element-190">
            Czy Ty też czasem czujesz, że zaraz eksplodujesz z błahego powodu?
          </h2>
          <p className="text-lg md:text-xl text-gray-600 mb-6" data-id="element-191">
            Jeśli wybuchasz przez kubek, skarpetki czy bałagan... jeśli płaczesz
            później z wyrzutów sumienia...
          </p>
          <p className="text-lg md:text-xl font-bold text-gray-800 mb-8" data-id="element-192">
            To nie dlatego, że jesteś słabą matką. To dlatego, że nikt ci nie
            powiedział prawdy o tym co dzieje się z twoim mózgiem.
          </p>
          {/* Initial credibility statement */}
          <div className="bg-white p-4 md:p-6 rounded-lg shadow-md border-l-4 border-blue-500 text-left max-w-3xl mx-auto" data-id="element-193">
            <p className="text-gray-700" data-id="element-194">
              Ten tekst napisała kobieta, która odkryła dlaczego wszystkie
              dotychczasowe sposoby na stres kompletnie nie działają na matki w
              naszej sytuacji.
            </p>
            <p className="text-gray-700 font-bold mt-2" data-id="element-195">
              I prostą metodę, która w 15 minut dziennie może wszystko zmienić -
              bez terapii, bez tabletek, bez porzucania obowiązków.
            </p>
          </div>
          {/* First CTA button */}
          <div className="mt-8 mb-4" data-id="element-196">
            <a href="https://veiramode.com/products/nie-zapomnij-o-sobie-ebook" className="inline-block bg-orange-500 hover:bg-orange-600 text-white font-bold py-3 px-8 rounded-lg text-lg md:text-xl shadow-lg transform hover:scale-105 transition-all" data-id="element-197">
              Odkryj 15-minutową metodę regeneracji →
            </a>
          </div>
          {/* Urgency element */}
          <div className="text-sm text-gray-500" data-id="element-198">
            <p data-id="element-199">Oferta ograniczona czasowo - pozostało:</p>
            <CountdownTimer hours={23} minutes={59} seconds={59} data-id="element-200" />
          </div>
        </div>
      </div>
    </header>;
};